import { useLocation } from 'react-router-dom';

import { NuxHeader } from './NuxHeader';
import { MainHeader } from './MainHeader';

const Header = (): JSX.Element => {
  const location = useLocation();

  const isNux = (): boolean => location.pathname.startsWith('/sitter/registration') || location.pathname.startsWith('/family-reg');

  return isNux() ? <NuxHeader /> : <MainHeader />;
};

export default Header;
